import React from "react";
import { motion, useInView, useReducedMotion } from "framer-motion";

/**
 * Reveal children on first intersection at 15% viewport.
 * opacity: 0 → 1, y: 24 → 0 over 600ms with the site ease.
 * Reduced-motion: renders children immediately (no animation).
 */
export function Reveal({
  as: As = "div",
  delay = 0,
  once = true,
  amount = 0.15,
  className,
  children,
  ...rest
}) {
  const ref = React.useRef(null);
  const inView = useInView(ref, { once, amount });
  const reduce = useReducedMotion();
  const MotionAs = motion[As] ?? motion.div;

  if (reduce) {
    return (
      <As ref={ref} className={className} {...rest}>
        {children}
      </As>
    );
  }

  return (
    <MotionAs
      ref={ref}
      initial={{ opacity: 0, y: 24 }}
      animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 24 }}
      transition={{
        duration: 0.6,
        ease: [0.2, 0.8, 0.2, 1],
        delay: delay / 1000,
      }}
      className={className}
      {...rest}
    >
      {children}
    </MotionAs>
  );
}

export default Reveal;
